import { WidgetDefinition } from '../../models/WidgetDefinition';

export const QualityPercentageEvolutionWidgetDefinition: WidgetDefinition = {
    baseType: 'qualityPercentageEvolution',
    group: 'Quality',
    highlights: [''],
    icon: '',
    sortingOrder: 0,
    title: '',
    type: 'qualityPercentageEvolution'
};